module.exports = __webpack_public_path__ + "static/media/1005634.dd4d85c8.jpg";